import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCategorySelect = (url: string) => {
    setDropdownOpen(false);
    setMobileMenuOpen(false);
    window.open(url, "_blank", "noopener");
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
      <div className="w-full px-4 md:px-10 py-3 flex items-center justify-between">
        <Link to="/" className="font-heading text-base md:text-xl font-bold text-foreground-950 tracking-tight whitespace-nowrap cursor-pointer">
          Mulebuy Spreadsheets
        </Link>

        <div className="hidden md:flex items-center gap-5">
          <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
            Home
          </Link>
          <Link to="/mulebuy-spreadsheet-guide" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
            Shopping Guide
          </Link>

          <div ref={dropdownRef} className="relative">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-foreground-900 border-b border-foreground-300 hover:border-foreground-600 transition-colors bg-transparent cursor-pointer whitespace-nowrap"
            >
              <span>All Categories</span>
              <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}>
                <i className="ri-arrow-down-s-line text-sm"></i>
              </span>
            </button>

            {dropdownOpen && (
              <div className="absolute right-0 mt-2 w-64 bg-background-50 border border-background-200/70 rounded-lg shadow-lg max-h-80 overflow-y-auto z-50">
                {categories.map((cat) => (
                  <button
                    key={cat.seq}
                    onClick={() => handleCategorySelect(cat.url)}
                    className="w-full text-left px-4 py-3 text-sm text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer border-b border-background-100 last:border-b-0 whitespace-nowrap"
                  >
                    {cat.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center ml-1">
              <i className="ri-arrow-right-up-line text-xs"></i>
            </span>
          </a>
        </div>

        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden flex items-center justify-center w-10 h-10 text-foreground-900 cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 max-h-[70vh] overflow-y-auto">
          <Link
            to="/"
            onClick={() => setMobileMenuOpen(false)}
            className="block py-3 text-sm font-semibold text-foreground-900 border-b border-background-100 cursor-pointer"
          >
            <span className="w-4 h-4 inline-flex items-center justify-center mr-2"><i className="ri-home-line"></i></span>
            Home
          </Link>
          <Link
            to="/mulebuy-spreadsheet-guide"
            onClick={() => setMobileMenuOpen(false)}
            className="block py-3 text-sm font-semibold text-foreground-900 border-b border-background-100 cursor-pointer"
          >
            <span className="w-4 h-4 inline-flex items-center justify-center mr-2"><i className="ri-book-open-line"></i></span>
            Shopping Guide
          </Link>
          <div className="border-b border-background-100">
            <p className="py-3 text-xs font-bold text-foreground-400 uppercase tracking-wider">Categories</p>
            {categories.map((cat) => (
              <button
                key={cat.seq}
                onClick={() => handleCategorySelect(cat.url)}
                className="block w-full text-left py-2.5 pl-6 text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap border-t border-background-100/50"
              >
                {cat.name}
              </button>
            ))}
          </div>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            onClick={() => setMobileMenuOpen(false)}
            className="block mt-3 text-center py-3 text-sm font-semibold text-primary-600 border border-primary-200 rounded-md cursor-pointer"
          >
            Buy It Now
            <span className="w-3 h-3 inline-flex items-center justify-center ml-1"><i className="ri-arrow-right-up-line text-xs"></i></span>
          </a>
        </div>
      )}
    </nav>
  );
}